import { Component } from '@angular/core';

@Component({
  selector: 'app-social-dinner24',
  templateUrl: './social-dinner24.component.html',
  styleUrl: './social-dinner24.component.css'
})
export class SocialDinner24Component {

}
